import { FormControl } from '@angular/forms';

const phoneNumberRegExp = new RegExp('^(([0-9]{3}-[0-9]{4})|((\\([0-9]{3}\\)[0-9]{3}-[0-9]{4})( x[0-9]{1,7})?))$');
export const phoneNumberValidator = (control: FormControl) => {
  if (control.value.length > 0) {
    return phoneNumberRegExp.test(control.value)
      ? null
      : {
          phoneNumber: 'Invalid Phone Number format',
        };
  }
  return null;
};
